import { jsPDF } from "jspdf"
import autoTable from "jspdf-autotable"

/**
 * Gera e baixa o PDF de uma Ordem de Serviço.
 * @param {object} dados
 * @param {string} dados.protocolo
 * @param {string} dados.data
 * @param {string} dados.condominio
 * @param {string} dados.responsavel
 * @param {string} dados.tipo
 * @param {string} dados.status
 * @param {string} [dados.descricao]
 * @param {Array<{nome: string, quantidade: string|number}>} [dados.itens]
 * @param {string|null} [dados.assinatura] - dataURL ou base64 PNG
 */
export const gerarPdfOS = dados => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" })
  const pageWidth = doc.internal.pageSize.getWidth()
  let y = 16

  doc.setFont("helvetica", "bold")
  doc.setFontSize(16)
  doc.setTextColor(52, 118, 246)
  doc.text("Syskeeper", 14, y)

  y += 8
  doc.setFontSize(13)
  doc.setTextColor(50, 50, 50)
  doc.text("Ordem de Serviço", 14, y)

  y += 10
  doc.setFont("helvetica", "normal")
  doc.setFontSize(10)
  doc.setTextColor(60, 60, 60)

  const linhas = [
    ["Protocolo", dados.protocolo || "—"],
    ["Data", dados.data || "—"],
    ["Condomínio", dados.condominio || "—"],
    ["Responsável", dados.responsavel || "—"],
    ["Tipo de Serviço", dados.tipo || "—"],
    ["Status", dados.status || "—"],
  ]

  linhas.forEach(([label, valor]) => {
    doc.setFont("helvetica", "bold")
    doc.text(`${label}:`, 14, y)
    doc.setFont("helvetica", "normal")
    const texto = doc.splitTextToSize(String(valor), pageWidth - 60)
    doc.text(texto, 55, y)
    y += Math.max(6, texto.length * 5)
  })

  if (dados.descricao) {
    y += 2
    doc.setFont("helvetica", "bold")
    doc.text("Descrição:", 14, y)
    y += 5
    doc.setFont("helvetica", "normal")
    const descLines = doc.splitTextToSize(String(dados.descricao), pageWidth - 28)
    doc.text(descLines, 14, y)
    y += descLines.length * 5 + 4
  }

  const itens = Array.isArray(dados.itens) ? dados.itens.filter(Boolean) : []
  if (itens.length > 0) {
    autoTable(doc, {
      startY: y,
      head: [["Item", "Quantidade"]],
      body: itens.map(i => [i.nome || "—", String(i.quantidade ?? "—")]),
      styles: { fontSize: 9 },
      headStyles: { fillColor: [52, 118, 246] },
      margin: { left: 14, right: 14 },
    })
    y = doc.lastAutoTable.finalY + 10
  }

  if (dados.assinatura) {
    if (y > 220) {
      doc.addPage()
      y = 20
    }
    doc.setFont("helvetica", "bold")
    doc.setFontSize(10)
    doc.text("Assinatura do Cliente:", 14, y)
    y += 4
    try {
      const imgData = dados.assinatura.startsWith("data:")
        ? dados.assinatura
        : `data:image/png;base64,${dados.assinatura}`
      doc.addImage(imgData, "PNG", 14, y, 80, 40)
      y += 44
    } catch (e) {
      doc.setFont("helvetica", "normal")
      doc.setFontSize(9)
      doc.setTextColor(150, 150, 150)
      doc.text("(Não foi possível renderizar a assinatura)", 14, y + 5)
    }
  }

  const nomeArquivo = `OS-${dados.protocolo || "sem-protocolo"}.pdf`
  doc.save(nomeArquivo)
  return nomeArquivo
}

export default gerarPdfOS
